import { Actions } from './DialogGuideActions'
import { Content } from './DialogGuideContent'
import { Root } from './DialogGuideRoot'
import { Title } from './DialogGuideTitle'

/**
 * @example
 * import Dialog from 'global/guides/Dialog'
 *
 * return <Dialog.Root>
 *      <Dialog.Title></Dialog.Title>
 *      <Dialog.Content></Dialog.Content>
 *      <Dialog.Actions>
 *          <Dialog.Actions.SecondaryButton />
 *          <Dialog.Actions.PrimaryButton />
 *      </Dialog.Actions>
 *  </Dialog.Root>
 */
const Dialog = {
    Root,
    Title,
    Content,
    Actions,
}

export default Dialog
